export enum ProsthesisType {
	// Below
	GlazeOneBelow = 'glaze-one-below',
	GlazeKidsBelow = 'glaze-kids-below',
	WhizzlinkBelow = 'whizzlink-below',
	WhizzlinkKidsBelow = 'whizzlink-kids-below',
	WhizzlinkEcoBelow = 'whizzlink-eco-below',
	// Above
	GlazeOneAbove = 'glaze-one-above',
	WhizzlinkAbove = 'whizzlink-above',
	WhizzlinkEcoAbove = 'whizzlink-eco-above',
	ErgoArmAbove = 'ergoarm-above',
	ErgoArmPlusAbove = 'ergoarm-plus-above',
	ErgoArmHybridPlusAbove = 'ergoarm-hybrid-plus-above',
	ErgoArmElectronicPlusAbove = 'ergoarm-electronic-plus-above',
	// Espire (Steeper) - GLA-62. Slug MUSI zawierac 'above': siedem warunkow we froncie
	// rozpoznaje po nim protezy powyzej lokcia (patrz GLA-59 i dlug GLA-65).
	EspireProAbove = 'espire-pro-above',
	EspireHybridAbove = 'espire-hybrid-above',
	EspireClassicPlusAbove = 'espire-classic-plus-above',
	EspireClassicAbove = 'espire-classic-above',

	// TERMINAL DEVICE ONLY
	NullProsthesis = 'null-prosthesis',

	//3d
	GlazeBasicBelow = 'glaze-basic-below',
}

export const ProsthesisDevicesDescription: Record<ProsthesisType, string> = {
	[ProsthesisType.GlazeOneBelow]:
		'You can select multiple devices. Our interchangeable system, used in Glaze products, allows for quick and convenient change of terminal devices.',
	[ProsthesisType.GlazeKidsBelow]:
		'You can select multiple devices. Our interchangeable system, used in Glaze products, allows for quick and convenient change of terminal devices.',
	[ProsthesisType.WhizzlinkBelow]:
		"Whizzlink device is designed to work with the most myoelectric hands available on the market. Unfortunately, different myoelectric systems are not interchangeable. Browse the producers' catalogs and choose one of the hands. Your Whizzlink will be configured and optimized for the device of your choosing.",
	[ProsthesisType.WhizzlinkKidsBelow]:
		"Whizzlink Kids is a myoelectric solution designed for thriving, energetic children. Browse the producers' catalogs and choose one of the hands. Your Whizzlink Kids will be configured and optimized for the device of your choice.",
	[ProsthesisType.WhizzlinkEcoBelow]:
		"Whizzlink Eco is probably the best solution on the market that combines modern aesthetics with functionality provided by myoelectric hand. Browse the producers' catalogs and choose one of the hands. Your Whizzlink Eco will be configured and optimized for the device of your choice.",
	[ProsthesisType.GlazeOneAbove]:
		'You can select multiple devices. Our interchangeable system, used in Glaze products, allows for quick and convenient change of terminal devices.',
	[ProsthesisType.WhizzlinkAbove]:
		"Whizzlink device is designed to work with the most myoelectric hands available on the market. Unfortunately, different myoelectric systems are not interchangeable. Browse the producers' catalogs and choose one of the hands. Your Whizzlink will be configured and optimized for the device of your choosing.",
	[ProsthesisType.WhizzlinkEcoAbove]:
		"Whizzlink Eco is probably the best solution on the market that combines modern aesthetics with functionality provided by myoelectric hand. Browse the producers' catalogs and choose one of the hands. Your Whizzlink Eco will be configured and optimized for the device of your choice.",
	[ProsthesisType.ErgoArmAbove]: 'You can select multiple devices.',
	[ProsthesisType.ErgoArmPlusAbove]: 'You can select multiple devices.',
	[ProsthesisType.ErgoArmHybridPlusAbove]: 'You can select multiple devices.',
	[ProsthesisType.ErgoArmElectronicPlusAbove]: 'You can select multiple devices.',
	[ProsthesisType.NullProsthesis]: '',
	[ProsthesisType.EspireProAbove]: 'You can select multiple devices.',
	[ProsthesisType.EspireHybridAbove]: 'You can select multiple devices.',
	[ProsthesisType.EspireClassicPlusAbove]: 'You can select multiple devices.',
	[ProsthesisType.EspireClassicAbove]: 'You can select multiple devices.',
	[ProsthesisType.GlazeBasicBelow]: 'You can select multiple devices.',
};
